import currencyFormatter from 'currency-formatter'

export default {
  name: 'currency',
  filter: (value, currency) => currencyFormatter.format(value, { code: currency })
}
